import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCardHeader,
  CCardFooter,
  CBadge,
  CInput,
  CSpinner,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CTooltip
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import SelectModal from "../CommunityModal/select";
import Loading from "../Loading";
import RichText from "../RichText/SlateEditor/Editor";

class CommunityContentNotices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      publishLoading: false,
      notices: null,
      // tab: 1,
      title: "",
      // description: "",
      selectModal: false,
      selectedActivities: [],
      selectedDocs: [],
      roles: [],
      selectedRoles: "Todos",
      ValorDescricao: null,
      zerar: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handleNotices();
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}access/role/list`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            roles: resp.data.data.map(item => ({
              role_id: item.id,
              role_type: item.type,
              group_id: this.props.general.active_roles.group_id,
              region_id: this.props.general.active_roles.region_id,
              school_id: this.props.general.active_roles.school_id,
              room_id: id
            }))
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  handleNotices() {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}communication/notice/list`,
        {
          room_id: id,
          user_id: this.props.user.user.id,
          role_id: this.props.general.active_roles.role_id
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setValorDescricao(null);
          this.setState({
            notices: resp.data.data,
            loading: false,
            title: "",
            // description: "",
            deleteModal: false,
            deleteId: null,
            selectedActivities: [],
            selectedDocs: [],
            zerar: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  insertNotice() {
    this.setState({ publishLoading: true });

    let { roles } = this.state;

    if (this.state.selectedRoles === "Administradores") {
      roles = roles.filter(item =>
        ["G", "U", "R", "E", "P"].includes(item.role_type)
      );
    } else if (this.state.selectedRoles === "Professores") {
      roles = roles.filter(item => item.role_type === "P");
    } else if (this.state.selectedRoles === "Alunos") {
      roles = roles.filter(item => item.role_type === "A");
    }

    const obj = {
      user_id: this.props.user.user.id,
      title: this.state.title,
      description: this.state.ValorDescricao
        ? JSON.stringify(this.state.ValorDescricao)
        : "",
      activities: this.state.selectedActivities.map(item => item.id),
      docs: this.state.selectedDocs.map(item => item.id),
      type: "notice",
      roles
    };

    if (this.state.title === "") {
      toastr.error("Atenção", "Digite um título para o aviso.");
      this.setState({ publishLoading: false });
    } else {
      axios
        .post(`${URL.api}communication/notice/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            this.setState({ publishLoading: false, zerar: true });

            this.handleNotices();
          },
          error => {
            this.error(error.response.statusText);
            this.setState({ publishLoading: false });
          }
        );
    }
  }

  deleteNotice() {
    this.setState({ deleteModal: false });
    axios
      .post(
        `${URL.api}communication/notice/delete/${this.state.deleteId}`,
        null,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success === false) {
            this.error(resp.data.error);
          } else {
            this.handleNotices();
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  closeModal(item, type) {
    if (item) {
      if (type === "activity") {
        this.setState(state => {
          const newList = state.selectedActivities.filter(
            activity => item.id !== activity.id
          );
          newList.push(item);

          return { selectedActivities: newList };
        });
      } else {
        this.setState(state => {
          const newList = state.selectedDocs.filter(doc => item.id !== doc.id);
          newList.push(item);

          return { selectedDocs: newList };
        });
      }
    }

    this.setState({ selectModal: false });
  }

  removeSelectedActivity(activity) {
    this.setState(state => {
      const newList = state.selectedActivities.filter(
        item => item.id !== activity.id
      );

      return { selectedActivities: newList };
    });
  }

  removeSelectedDoc(doc) {
    this.setState(state => {
      const newList = state.selectedDocs.filter(item => item.id !== doc.id);

      return { selectedDocs: newList };
    });
  }

  setValorDescricao = val => {
    this.setState({
      ValorDescricao: val
    });
  };

  render() {
    const { id } = this.props.match.params;
    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            <CModal
              show={this.state.deleteModal}
              onClose={() => this.setState({ deleteModal: false })}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton className="bg-danger">
                <CModalTitle>Apagar aviso</CModalTitle>
              </CModalHeader>
              <CModalBody>Deseja apagar o aviso selecionado?</CModalBody>
              <CModalFooter>
                <CButton color="danger" onClick={() => this.deleteNotice()}>
                  Apagar
                </CButton>{" "}
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ deleteModal: false })}
                >
                  Cancelar
                </CButton>
              </CModalFooter>
            </CModal>
            {this.state.selectModal && (
              <SelectModal
                room={id}
                onClose={(selected, type) => this.closeModal(selected, type)}
                isRoom={this.props.isRoom}
              />
            )}
            {this.props.hasPrivilege && (
              <CCard>
                <CCardHeader className="d-flex align-items-center">
                  <CInput
                    value={this.state.title}
                    onChange={e => this.setState({ title: e.target.value })}
                    placeholder="Título do aviso"
                    type="text"
                    className="border-0 p-0 shadow-none"
                    style={{ fontSize: "1rem", fontWeight: "bold", flex: 1 }}
                  />
                  <CDropdown
                    className="ml-2"
                    style={{
                      border: "1px solid #d8dbe0",
                      borderRadius: "0.25rem"
                    }}
                  >
                    <CDropdownToggle>
                      <span className="mr-1">{this.state.selectedRoles}</span>
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem
                        onClick={() =>
                          this.setState({ selectedRoles: "Todos" })
                        }
                        active={this.state.selectedRoles === "Todos"}
                      >
                        Todos
                      </CDropdownItem>
                      <CDropdownItem
                        onClick={() =>
                          this.setState({ selectedRoles: "Administradores" })
                        }
                        active={this.state.selectedRoles === "Administradores"}
                      >
                        Administradores
                      </CDropdownItem>
                      <CDropdownItem
                        onClick={() =>
                          this.setState({ selectedRoles: "Professores" })
                        }
                        active={this.state.selectedRoles === "Professores"}
                      >
                        Professores
                      </CDropdownItem>
                      <CDropdownItem
                        onClick={() =>
                          this.setState({ selectedRoles: "Alunos" })
                        }
                        active={this.state.selectedRoles === "Alunos"}
                      >
                        Estudantes
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </CCardHeader>
                {/* <CCardBody> */}
                {/* <CTextarea
                    value={this.state.description}
                    onChange={e =>
                      this.setState({ description: e.target.value })
                    }
                    className="border-0 p-0 shadow-none"
                    placeholder="Escreva um aviso para a turma 222"
                    rows={6}
                    style={{ resize: "none" }}
                  /> */}
                <RichText
                  setValorDescricao={val =>
                    this.setState({ ValorDescricao: val })
                  }
                  placeholder="Escreva um aviso para a turma"
                  // eslint-disable-next-line react/jsx-boolean-value
                  description=""
                  editavel
                  zerar={this.state.zerar}
                />
                {/* </CCardBody> */}
                <CCardFooter className="d-flex">
                  <div
                    className="d-flex align-items-center"
                    style={{ flex: 1 }}
                  >
                    <div
                      className="c-avatar mr-2 btn-light cursor"
                      onClick={() => this.setState({ selectModal: true })}
                    >
                      <i className="fa fa-plus text-muted"></i>
                    </div>
                    {this.state.selectedActivities.map(activity => (
                      <CTooltip content={activity.name}>
                        <div className="c-avatar mr-2 bg-primary cursor position-relative">
                          <i className="fa fa-line-chart"></i>
                          <div
                            className="btn-dark text-white selected-activity-close"
                            onClick={() =>
                              this.removeSelectedActivity(activity)
                            }
                          >
                            <i className="fa fa-close"></i>
                          </div>
                        </div>
                      </CTooltip>
                    ))}
                    {this.state.selectedDocs.map(doc => (
                      <CTooltip content={doc.name}>
                        <div className="c-avatar mr-2 bg-light cursor">
                          <i className="fa fa-file text-muted"></i>
                          <div
                            className="btn-dark text-white selected-activity-close"
                            onClick={() => this.removeSelectedDoc(doc)}
                          >
                            <i className="fa fa-close"></i>
                          </div>
                        </div>
                      </CTooltip>
                    ))}
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="c-avatar mr-3">
                      <img
                        className="c-avatar-img"
                        src={
                          URL.img +
                          (this.props.user.user.photo ||
                            "uploads/users/profileEmpty.jpg")
                        }
                        alt=""
                      />
                    </div>
                    <CButton
                      color="primary"
                      onClick={() => this.insertNotice()}
                      disabled={this.state.publishLoading}
                      style={{ position: "relative" }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <span
                        style={
                          this.state.publishLoading ? { opacity: 0 } : null
                        }
                      >
                        Publicar
                      </span>
                      {this.state.publishLoading && (
                        <CSpinner
                          color="white"
                          size="sm"
                          style={{ position: "absolute" }}
                        />
                      )}
                    </CButton>
                  </div>
                </CCardFooter>
              </CCard>
            )}
            {this.state.notices &&
            this.state.notices.filter(notice =>
              notice.title
                .toLowerCase()
                .includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              <React.Fragment>
                {this.state.notices
                  .filter(notice =>
                    notice.title
                      .toLowerCase()
                      .includes(this.props.search.toLowerCase())
                  )
                  .map(notice => (
                    <CCard key={notice.id}>
                      <CCardBody>
                        <div>
                          <div className="d-flex align-items-center">
                            <div className="c-avatar mr-2">
                              <img
                                className="c-avatar-img"
                                src={
                                  URL.img +
                                  (notice.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                alt=""
                              />
                            </div>
                            <div className="d-block w-100">
                              <div className="d-flex">
                                <span className="d-flex" style={{ flex: 1 }}>
                                  {notice.user_name}
                                </span>
                                {notice.user_id === this.props.user.user.id && (
                                  <CDropdown className="card-notice-menu">
                                    <CDropdownToggle
                                      color="white"
                                      className="card-header-action remove-caret"
                                    >
                                      <i className="fa fa-ellipsis-v"></i>
                                    </CDropdownToggle>
                                    <CDropdownMenu placement="top">
                                      <CDropdownItem
                                        onClick={() =>
                                          this.setState({
                                            deleteModal: true,
                                            deleteId: notice.id
                                          })
                                        }
                                      >
                                        Apagar
                                      </CDropdownItem>
                                    </CDropdownMenu>
                                  </CDropdown>
                                )}
                              </div>
                              <div className="text-muted">
                                {this.friendlyDate(notice.created_at)}
                              </div>
                            </div>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "1rem", fontWeight: "bold" }}
                          >
                            {notice.title}
                          </div>
                        </div>
                        {notice.description != null &&
                        notice.description.substring(0, 1) === "[" ? (
                          <RichText
                            description={notice.description}
                            editavel={false}
                          />
                        ) : (
                          <div className="mt-2">{notice.description}</div>
                        )}
                        {/* 
                        {notice.description && (
                          <div className="mt-2">
                            {linkify(notice.description)}
                          </div>
                        )} */}
                      </CCardBody>
                      {(notice.docs.length > 0 ||
                        notice.activities.length > 0) && (
                        <CCardFooter className="justify-content-start">
                          {notice.activities.map(activity => (
                            <CBadge
                              color={
                                activity.type_id === 2 ? "danger" : "primary"
                              }
                              className={`mfe-2 p-2 cursor btn-${
                                activity.type_id === 2 ? "danger" : "primary"
                              }`}
                              to={`/activity/${
                                activity.type_id === 2 ? "live" : "do"
                              }/${activity.allocation_id}`}
                              target={activity.type_id === 2 ? "_blank" : null}
                            >
                              <i
                                className={`fa fa-${
                                  activity.type_id === 2
                                    ? "circle"
                                    : "check-square"
                                } mr-2`}
                              ></i>
                              {activity.name}
                            </CBadge>
                          ))}
                          {notice.docs.map(doc => (
                            <CBadge
                              color="light"
                              className="mfe-2 p-2 cursor btn-light"
                              onClick={() =>
                                this.props.navigate(
                                  `${
                                    (this.props.isRoom
                                      ? "/room/"
                                      : "/classroom/") + id
                                  }/docs`
                                )
                              }
                            >
                              <i className="fa fa-file mr-2"></i>
                              {doc.name}
                            </CBadge>
                          ))}
                        </CCardFooter>
                      )}
                    </CCard>
                  ))}
              </React.Fragment>
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Nenhum aviso encontrado
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentNotices);
